var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1485497"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2159",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#AC3049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.93771 7.00277L9.80428 5.13448C10.0652 4.87327 10.0652 4.45268 9.80428 4.1959C9.54331 3.9347 9.12311 3.9347 8.86657 4.1959L7 6.06419L5.13343 4.1959C4.87247 3.9347 4.45669 3.9347 4.19572 4.1959C3.93476 4.45268 3.93476 4.87327 4.19572 5.13448L6.06229 7.00277L4.19572 8.86663C3.93476 9.12784 3.93476 9.54842 4.19572 9.8052C4.324 9.93359 4.4965 10 4.66458 10C4.83266 10 5.00516 9.93359 5.13343 9.8052L7 7.93691L8.86657 9.8052C8.99484 9.93359 9.16734 10 9.33542 10C9.5035 10 9.676 9.93359 9.80428 9.8052C10.0652 9.544 10.0652 9.12341 9.80428 8.86663L7.93771 6.99834V7.00277Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.cde4626f61084c0fe3f53575dd75ffd5.svg";
export { ForwardRef as ReactComponent };